export default __webpack_public_path__ + "static/step9-e3ebbcf2baf8164fcd6328ec2a4ad794.svg";